import React from 'react';
import { Link , useHistory } from 'react-router-dom';
import { FiLogOut } from "react-icons/fi";

import './Nav.scss';
import { useGlobalContext } from '../../../context/GlobalContext';
import Filters from '../Filters/Filters';
import logo from '../../../assets/images/logo.svg';

export default function Nav({ activePage }) {

  // const [ mobileNavIsActive , setMobileNavIsActive ] = useState(false);

  const dispatch = useGlobalContext()[1];
  const history = useHistory();

  function logout() {
    history.push("/");
    localStorage.removeItem('token');
    dispatch({
      type : 'IS_AUTH',
      payload : false
    });
    dispatch({
      type : 'USER_AUTH',
      payload : null
    });
  };

  return (
    <>
    <nav className={`${activePage === "login" ? "" : "isActive"}`}>
      <div className="content">

        <Link to={'/admin'}>
          <div className="logo">
            <img src={logo} alt=""/>
          </div>
        </Link>

        <Filters isDisabled={activePage !== "stock"}/>

        <div className="links">
          <Link to={'/admin/upload'} className={`${activePage === "upload" ? "isActive" : ""}`}>UPLOAD DES DONNÉES</Link>
          <Link to={'/admin'} className={`${activePage === "stock" ? "isActive" : ""}`}>CONTINGENTEMENT</Link>
          <Link to={'/admin/expirations'} className={`${activePage === "expirations" ? "isActive" : ""}`}>Péremption</Link>
        </div>
        
        <div className="icons">

          {/* <Link to="/account">
            <FiUser size={22} color={"#192243"}/>
          </Link> */}

          <button className="logout" onClick={() => logout()}>
            <FiLogOut size={22} color={"#192243"}/>
          </button>

          {/* <button className="mobile-toggle" onClick={() => setMobileNavIsActive(!mobileNavIsActive)}>
            {mobileNavIsActive ? <VscChromeClose size={22} color={"#192243"}/> : <VscMenu size={22} color={"#192243"}/>}
          </button> */}

        </div>

      </div>

    </nav>
      {/* <div
        onClick={() => setMobileNavIsActive(!mobileNavIsActive)}
        className={`links-mobile ${mobileNavIsActive ? "isActive" : ""}`}>
        <Link to="/" className={`${activePage === "patient" ? "isActive" : ""}`}>patients</Link>
        <Link to="/pathology" className={`${activePage === "pathology" ? "isActive" : ""}`}>maladies</Link>
        <Link to="/account" className={`${activePage === "account" ? "isActive" : ""}`} >Mon compte</Link>
        <button className="logout" onClick={() => logout()}>
          Déconnexion
        </button>
      </div> */}
    </>
  )
}
